/**
 * ISO 639-1 language codes supported by the app.
 * 'auto' means "let the model detect the source language".
 */
export const AUTO_LANG = 'auto';
export const SUPPORTED_LANGUAGES = [
    { code: 'en', nameEn: 'English', nameRu: 'Английский' },
    { code: 'ru', nameEn: 'Russian', nameRu: 'Русский' },
    { code: 'es', nameEn: 'Spanish', nameRu: 'Испанский' },
    { code: 'fr', nameEn: 'French', nameRu: 'Французский' },
    { code: 'de', nameEn: 'German', nameRu: 'Немецкий' },
    { code: 'it', nameEn: 'Italian', nameRu: 'Итальянский' },
    { code: 'pt', nameEn: 'Portuguese', nameRu: 'Португальский' },
    { code: 'pl', nameEn: 'Polish', nameRu: 'Польский' },
    { code: 'tr', nameEn: 'Turkish', nameRu: 'Турецкий' },
    { code: 'uk', nameEn: 'Ukrainian', nameRu: 'Украинский' },
    { code: 'zh', nameEn: 'Chinese', nameRu: 'Китайский' },
    { code: 'ja', nameEn: 'Japanese', nameRu: 'Японский' },
    { code: 'ko', nameEn: 'Korean', nameRu: 'Корейский' },
    { code: 'ar', nameEn: 'Arabic', nameRu: 'Арабский' },
    { code: 'hi', nameEn: 'Hindi', nameRu: 'Хинди' },
    { code: 'nl', nameEn: 'Dutch', nameRu: 'Нидерландский' },
    { code: 'sv', nameEn: 'Swedish', nameRu: 'Шведский' },
    { code: 'cs', nameEn: 'Czech', nameRu: 'Чешский' },
    { code: 'el', nameEn: 'Greek', nameRu: 'Греческий' },
    { code: 'he', nameEn: 'Hebrew', nameRu: 'Иврит' },
];
export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);
export const SOURCE_LANGUAGE_CODES = [AUTO_LANG, ...SUPPORTED_LANGUAGE_CODES];
export function isSupportedTargetLang(code) {
    return SUPPORTED_LANGUAGE_CODES.includes(code);
}
export function isSupportedSourceLang(code) {
    return code === AUTO_LANG || SUPPORTED_LANGUAGE_CODES.includes(code);
}
export function getLanguageName(code, locale) {
    if (code === AUTO_LANG)
        return locale === 'ru' ? 'Авто' : 'Auto';
    const lang = SUPPORTED_LANGUAGES.find((l) => l.code === code);
    if (!lang)
        return code;
    return locale === 'ru' ? lang.nameRu : lang.nameEn;
}
